export const CONTACT = {
  contactPerson: "Ashwin Jadhav",
  phone: "+91 76662 88210",
  phoneRaw: "917666288210",
  phone2: "+91 96999 54431",
  phone2Raw: "919699954431",
  whatsapp: "917666288210",
  email: "ashwinjadhao104@gmail.com",
  gstin: "27ABCDE1234F1Z5",
  hours: "Mon – Sat · 9:00 AM – 7:00 PM",
  address: "Imamwada Road, Dalda Company Chowk, Gujar Wadi, Nagpur, Maharashtra 440018",
};

export const METRICS = [
  { value: "15+", label: "Years Experience" },
  { value: "500+", label: "Projects Delivered" },
  { value: "ISO 9001:2015", label: "& MSME Certified" },
  { value: "IS 800/2062", label: "Compliant" },
];

export const SERVICES = [
  {
    no: "01",
    icon: "Warehouse",
    title: "Industrial & PEB Sheds",
    desc: "Turnkey factory sheds and logistics warehouses engineered for MIDC zones — from foundation bolts to roofing sheets.",
    tags: ["Factory Sheds", "PEB", "Warehouses"],
    img: "https://customer-assets-39nsmqrw.emergentagent.net/job_steel-solutions-mh/artifacts/c0vu2eci_WhatsApp%20Image%202026-08-17%20at%2013.37.54%20%281%29.jpeg",
    span: "lg:col-span-3 lg:row-span-2",
  },
  {
    no: "02",
    icon: "Container",
    title: "Heavy Industrial Fabrication",
    desc: "Storage tanks, silos, hoppers and code-compliant pressure vessels fabricated to IS standards.",
    tags: ["Tanks", "Silos", "Pressure Vessels"],
    img: "https://images.unsplash.com/photo-1588494251642-1333faa472e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxzdGVlbCUyMHN0b3JhZ2UlMjB0YW5rfGVufDB8fHx8MTc4Njk1NDE3MHww&ixlib=rb-4.1.0&q=85&w=1200",
    span: "lg:col-span-3",
  },
  {
    no: "03",
    icon: "Wheat",
    title: "Agri & Agro-Processing",
    desc: "Cotton ginning chutes, conveyor systems and grain storage structures for Vidarbha's agri belt.",
    tags: ["Ginning Chutes", "Conveyors", "Grain Storage"],
    img: "https://images.unsplash.com/photo-1556114846-f753bec8a9f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxzaWxvfGVufDB8fHx8MTc4Njk1NDE3MHww&ixlib=rb-4.1.0&q=85&w=1200",
    span: "lg:col-span-3",
  },
  {
    no: "04",
    icon: "Zap",
    title: "Commercial & Laser Cutting",
    desc: "Mezzanine floors, structural staircases and precision CNC laser cutting job-work with tight tolerances.",
    tags: ["Mezzanines", "Staircases", "CNC Laser"],
    img: "https://images.unsplash.com/photo-1735494033576-9c882e80504c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxjbmMlMjBsYXNlciUyMGN1dHRpbmd8ZW58MHx8fHwxNzg2OTU0MTcwfDA&ixlib=rb-4.1.0&q=85&w=1200",
    span: "lg:col-span-6",
  },
];

export const MACHINERY = [
  { code: "LX-12", name: "CNC Fiber Laser Cutting", spec: "12 kW", detail: "High-speed precision cutting up to 25mm MS plate" },
  { code: "PB-4R", name: "4-Roll Heavy Plate Bending", spec: "30 mm", detail: "Hydraulic rolling of shells & cones up to 3m width" },
  { code: "WLD-3", name: "MIG / TIG / SMAW Welding", spec: "Multi", detail: "Certified welders across all process stations" },
  { code: "EOT-20", name: "Overhead EOT Cranes", spec: "20 Ton", detail: "Twin-girder handling for heavy assemblies" },
];

export const GALLERY = [
  { id: 101, cat: "Industrial Sheds", title: "Steel Roofing Truss Structure", location: "Nagpur", tat: "26 Days", real: true, img: "https://customer-assets-39nsmqrw.emergentagent.net/job_steel-solutions-mh/artifacts/c0vu2eci_WhatsApp%20Image%202026-08-17%20at%2013.37.54%20%281%29.jpeg" },
  { id: 102, cat: "Industrial Sheds", title: "Rooftop Shed - On-Site Erection", location: "Amravati", tat: "14 Days", real: true, img: "https://customer-assets-39nsmqrw.emergentagent.net/job_steel-solutions-mh/artifacts/5vy21lco_WhatsApp%20Image%202026-08-17%20at%2013.37.55.jpeg" },
  { id: 103, cat: "Commercial", title: "Terrace Shed & Aluminium Glazing", location: "Nagpur", tat: "20 Days", real: true, img: "https://customer-assets-39nsmqrw.emergentagent.net/job_steel-solutions-mh/artifacts/q7u2qtih_WhatsApp%20Image%202026-08-17%20at%2013.37.56.jpeg" },
  { id: 104, cat: "Commercial", title: "Custom MS Steel Benches", location: "Wardha", tat: "5 Days", real: true, img: "https://customer-assets-39nsmqrw.emergentagent.net/job_steel-solutions-mh/artifacts/5ukh3uhp_WhatsApp%20Image%202026-08-17%20at%2013.37.54.jpeg" },
  { id: 105, cat: "Commercial", title: "Stainless Steel Window Grille", location: "Nagpur", tat: "4 Days", real: true, img: "https://customer-assets-39nsmqrw.emergentagent.net/job_steel-solutions-mh/artifacts/norco1ag_WhatsApp%20Image%202026-08-17%20at%2013.37.54%20%282%29.jpeg" },
  { id: 1, cat: "Industrial Sheds", title: "PEB Factory Shed", location: "Butibori MIDC", tat: "68 Days", img: "https://images.unsplash.com/photo-1669003750652-2027bd69e7a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwc3RlZWwlMjBzaGVkfGVufDB8fHx8MTc4Njk1NDE3MHww&ixlib=rb-4.1.0&q=85&w=1000" },
  { id: 2, cat: "Storage Tanks", title: "SS Storage Tank Farm", location: "Chandrapur", tat: "45 Days", img: "https://images.unsplash.com/photo-1588494251642-1333faa472e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxzdGVlbCUyMHN0b3JhZ2UlMjB0YW5rfGVufDB8fHx8MTc4Njk1NDE3MHww&ixlib=rb-4.1.0&q=85&w=1000" },
  { id: 3, cat: "Commercial", title: "CNC Laser Job Work", location: "Nagpur", tat: "7 Days", img: "https://images.unsplash.com/photo-1735494033576-9c882e80504c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxjbmMlMjBsYXNlciUyMGN1dHRpbmd8ZW58MHx8fHwxNzg2OTU0MTcwfDA&ixlib=rb-4.1.0&q=85&w=1000" },
  { id: 4, cat: "Industrial Sheds", title: "Logistics Warehouse", location: "MIHAN SEZ", tat: "90 Days", img: "https://images.unsplash.com/photo-1669003750747-3f139e115bfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwc3RlZWwlMjBzaGVkfGVufDB8fHx8MTc4Njk1NDE3MHww&ixlib=rb-4.1.0&q=85&w=1000" },
  { id: 5, cat: "Storage Tanks", title: "Cement Silo Cluster", location: "Nagpur", tat: "52 Days", img: "https://images.unsplash.com/photo-1589725971211-7e86a631e2c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzaWxvfGVufDB8fHx8MTc4Njk1NDE3MHww&ixlib=rb-4.1.0&q=85&w=1000" },
  { id: 6, cat: "Commercial", title: "Structural Staircase", location: "Wardha", tat: "18 Days", img: "https://images.pexels.com/photos/257727/pexels-photo-257727.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 7, cat: "Storage Tanks", title: "Pressure Vessel Unit", location: "Amravati", tat: "60 Days", img: "https://images.unsplash.com/photo-1627052428109-576e839d100a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxzaWxvfGVufDB8fHx8MTc4Njk1NDE3MHww&ixlib=rb-4.1.0&q=85&w=1000" },
  { id: 8, cat: "Commercial", title: "Mezzanine Floor", location: "Butibori MIDC", tat: "22 Days", img: "https://images.unsplash.com/photo-1721605236886-7467b289f450?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxzdGVlbCUyMHN0YWlyY2FzZXxlbnwwfHx8fDE3ODY5NTQxNzB8MA&ixlib=rb-4.1.0&q=85&w=1000" },
];

export const GALLERY_TABS = ["All", "Industrial Sheds", "Storage Tanks", "Commercial"];

export const SERVICE_OPTIONS = [
  "Industrial Shed",
  "PEB",
  "Heavy Vessel",
  "Laser Cutting",
  "Other",
];

export const LOCATIONS = ["Nagpur", "Chandrapur", "Amravati", "Wardha", "Yavatmal", "Butibori MIDC"];

export const TESTIMONIALS = [
  {
    name: "Rajesh Deshmukh",
    role: "Plant Manager, Agro Processing Unit",
    place: "Chandrapur",
    quote: "Nidhi delivered our storage silo cluster three weeks ahead of schedule. The welding quality passed our third-party inspection on the first pass.",
  },
  {
    name: "Sunil Patil",
    role: "Infrastructure Contractor",
    place: "Butibori MIDC",
    quote: "We've handed them four PEB sheds now. IS-compliant drawings, honest tonnage estimates, and cranes on site when they say. Rare in this region.",
  },
  {
    name: "Amit Khandelwal",
    role: "Director, Logistics Warehousing",
    place: "MIHAN SEZ",
    quote: "The 12kW laser job-work turnaround is genuinely fast. Complex brackets cut to spec, no rework. They've become our default fabricator.",
  },
];

export const MARQUEE_ITEMS = [
  "MADE IN INDIA",
  "ISO 9001:2015",
  "MSME UDYAM REGISTERED",
  "IS 800 / 2062 COMPLIANT",
  "12kW CNC FIBER LASER",
  "20-TON EOT CRANES",
  "500+ PROJECTS DELIVERED",
  "आत्मनिर्भर भारत",
];
